var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-row',{staticClass:"text-center"},[_c('v-col',[_c('div',{staticClass:"ma-3 text-h4"},[_vm._v("Hier entsteht das Leaderboard")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }